export enum LocalStorageKeys {
  UserStore = 'new-funday-userStore',
  Gender = 'sex',
  SharingKey = 'SharingKey',
  MGMCode = 'MGMCode',
  HasSeenEventCard = 'hasSeenEventCard',
  FunTVExclude = 'funTVExclude',
  FunTVExcludeNew = 'funTVExcludeNew',
  TabsCount = 'tabsCount',
  ToeicStore = 'toeicStore',
  LearningProgress = 'learningProgress',
  GiftCode = 'giftCode',
  AiChatStore = 'aiChatResult',
  AppStore = 'NewFundayAppStore',
  // 認養問卷彈窗 2026-01-01 起正式停用
  // QuestionnaireIsShowed = 'questionnaireIsShowed',
  Log = 'log',
  // 公告 - 今天不再顯示
  BulletinHideToday = 'bulletin-hide-today',
  TelemarketingQuestionnaire = 'telemarketing-q-hide-today',
  // 登入後導向次數 (用於輪替導向 AI 助教 / 社群大廳)
  LoginRedirectCount = 'loginRedirectCount',
  // 線上真人客服 widget 回傳的內網 ID
  LiveChatIntranetId = 'liveChatIntranetId',
  // 免費會員點擊上課的通知信寄送紀錄 (同一課程當日只寄一次)
  FreeUserAttendClassNotify = 'freeUserAttendClassNotify'
}
